import { render, staticRenderFns } from "./EditMedicationDialog.vue?vue&type=template&id=1c90b70a&"
import script from "./EditMedicationDialog.vue?vue&type=script&lang=js&"
export * from "./EditMedicationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports